export default "__VITE_PUBLIC_ASSET__4ef94939__"